import PropTypes from 'prop-types'

import ToggleButtonGroup from 'components/Shared/ToggleButtonGroup/Index'

const EmoSwitcher = ({ value, onChange }) => {
  const buttons = [
    { value: 'positive', iconName: 'icon-happy', buttonType: 'success' },
    { value: 'neutral', iconName: 'icon-neutral', buttonType: 'paused' },
    { value: 'negative', iconName: 'icon-unhappy', buttonType: 'alert' },
  ]

  return (
    <ToggleButtonGroup
      value={value}
      buttons={buttons}
      onChange={onChange}
    />
  )
}

EmoSwitcher.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default EmoSwitcher
